export const collectionReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_COLLECTIONS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        collections: null,
      };
    case "GET_COLLECTIONS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };
    case "GET_COLLECTIONS_LIST_FAILED":
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };

    case "GET_SUB_COLLECTIONS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        subCollections: null,
      };
    case "GET_SUB_COLLECTIONS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        subCollections: action.payload,
      };
    case "GET_SUB_COLLECTIONS_LIST_FAILED":
      return {
        ...state,
        loading: false,
        subCollections: action.payload,
      };

    case "ADD_COLLECTION_REQUEST":
      return {
        ...state,
        loading: true,
        collections: null,
      };
    case "ADD_COLLECTION_SUCCESS":
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };
    case "ADD_COLLECTION_FAILED":
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };
    case "ADD_SUB_COLLECTION_REQUEST":
      return {
        ...state,
        loading: true,
        collections: null,
      };
    case "ADD_SUB_COLLECTION_SUCCESS":
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };
    case "ADD_SUB_COLLECTION_FAILED":
      return {
        ...state,
        loading: false,
        collections: action.payload,
      };
    case "VIEW_COLLECTION_REQUEST":
      return {
        ...state,
        loading: true,
        individualCollection: null,
      };
    case "VIEW_COLLECTION_SUCCESS":
      return {
        ...state,
        loading: false,
        individualCollection: action.payload,
      };
    case "VIEW_COLLECTION_FAILED":
      return {
        ...state,
        loading: false,
        individualCollection: action.payload,
      };
    default:
      return state;
  }
};
